export const UPDATE_MAIN_MENU = "UPDATE_MAIN_MENU";

export const updateMainMenu = (val) => ({
    type: UPDATE_MAIN_MENU,
    val
})